import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBooleanGroupIntersect"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2.75C8 2.33579 8.33579 2 8.75 2H21.25C21.6642 2 22 2.33579 22 2.75V15.25C22 15.6642 21.6642 16 21.25 16H16V21.25C16 21.6642 15.6642 22 15.25 22H2.75C2.33579 22 2 21.6642 2 21.25V8.75C2 8.33579 2.33579 8 2.75 8H8V2.75ZM16 14.5V8.75C16 8.33579 15.6642 8 15.25 8H9.5V3.5H20.5V14.5H16ZM8 9.5H3.5V20.5H14.5V16H8.75C8.33579 16 8 15.6642 8 15.25V9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect;
